export enum LinkAction {
	SHOW_INSERT_TOOLBAR = 'SHOW_INSERT_TOOLBAR',
	HIDE_TOOLBAR = 'HIDE_TOOLBAR',
	SELECTION_CHANGE = 'SELECTION_CHANGE',
	INSERT_LINK_TOOLBAR = 'INSERT',
	EDIT_INSERTED_TOOLBAR = 'EDIT_INSERTED_TOOLBAR',
	SET_CONFIGURE_BUTTON_TARGET_POS = 'SET_CONFIGURE_BUTTON_TARGET_POS',
	SET_CONFIGURE_DROPDOWN_OPEN = 'SET_CONFIGURE_DROPDOWN_OPEN',
}
